import { Active, Over } from '@dnd-kit/core';

import { MenuEditorDragActive, MenuEditorDragEventData, MenuEditorDragOver } from './types';

const isMenuDragEvent = (eventData: Active | Over): eventData is MenuEditorDragActive | MenuEditorDragOver =>
  !!eventData.data.current?.type;

export const getMenuEditorDragEventData = (eventData: Active | Over): null | MenuEditorDragEventData => {
  if (!isMenuDragEvent(eventData)) {
    return null;
  }

  switch (eventData.data.current.type) {
    case 'DND_EDITOR_MULTIPLE_ITEMS': {
      const { selectedIds, dragOverlay } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        selectedIds,
        dragOverlay,
      };
    }
    case 'DND_EDITOR_MULTIPLE_NO_CATEGORY_ITEMS': {
      const { selectedIds, dragOverlay } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        selectedIds,
        dragOverlay,
      };
    }
    case 'DND_EDITOR_SINGLE_ITEM': {
      const { dragOverlay } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        dragOverlay,
      };
    }
    case 'DND_EDITOR_SINGLE_NO_CATEGORY_ITEM': {
      const { dragOverlay } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        dragOverlay,
      };
    }
    case 'DND_NAVIGATION_CATEGORY': {
      const { dragOverlay, shrinkOverlayTypes } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        category: eventData.data.current.category,
        dragOverlay,
        shrinkOverlayTypes,
      };
    }
    case 'DND_NAVIGATION_NO_CATEGORY': {
      const { shrinkOverlayTypes } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        shrinkOverlayTypes,
      };
    }
    case 'DND_ACCORDION_NAVIGATION_CATEGORY': {
      const { dragOverlay, shrinkOverlayTypes } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        category: eventData.data.current.category,
        dragOverlay,
        shrinkOverlayTypes,
      };
    }
    case 'DND_NAVIGATION_SUBCATEGORY': {
      const { dragOverlay, shrinkOverlayTypes, parentCategoryId, subcategory } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        parentCategoryId,
        dragOverlay,
        shrinkOverlayTypes,
        subcategory,
      };
    }
    case 'DND_NAVIGATION_LINKS': {
      const { shrinkOverlayTypes } = eventData.data.current;
      return {
        type: eventData.data.current.type,
        id: eventData.id,
        shrinkOverlayTypes,
      };
    }
    case 'DND_IMAGE_GALLERY_ASSET': {
      const { id, type, dragOverlay, imageData } = eventData.data.current;
      return {
        id,
        type,
        dragOverlay,
        imageData,
      };
    }
    case 'DND_OFFER_HEADER': {
      return {
        type: eventData.data.current.type,
        id: eventData.id,
      };
    }
  }
};
